// The anchor of the streak texture of the textures, at its head: a shot is drawn where it is.
export const STREAK_HEAD = 40 / 48;
